module.exports = __webpack_public_path__ + "img/Background_black.4e024c25.png";